<mat-dialog-content>
  <lemon-dialog-header> Ajasta palveluntarjoajan vaihto </lemon-dialog-header>

  <div class="dialog-content">
    <div class="info-message" style="background-color: #e3f2fd; padding: 15px; border-radius: 4px; margin-bottom: 20px">
      <span>{{ getInfoMessage() }}</span>
    </div>

    <form>
      <mat-form-field style="width: 100%; margin-bottom: 20px">
        <mat-label>Uusi palveluntarjoaja</mat-label>
        <mat-select [formField]="lomake.uusiAlatyyppi">
          @for (provider of data.availableProviders; track provider) {
            <mat-option [value]="provider.value">
              {{ provider.label }}
            </mat-option>
          }
        </mat-select>
        @if (onkoVirhe(lomake.uusiAlatyyppi, 'required')) {
          <mat-error> Valitse uusi palveluntarjoaja </mat-error>
        }
      </mat-form-field>

      <mat-form-field style="width: 100%">
        <mat-label>Voimaantulopäivä</mat-label>
        <input matInput [matDatepicker]="picker" [formField]="lomake.voimassaAlkaen" autocomplete="off" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if (onkoVirhe(lomake.voimassaAlkaen, 'required')) {
          <mat-error> Valitse voimaantulopäivä </mat-error>
        }
        @if (onkoVirhe(lomake.voimassaAlkaen, 'minDate')) {
          <mat-error> Voimaantulopäivä saa olla {{ minDate | date: 'dd.MM.yyyy' }} tai sen jälkeen </mat-error>
        }
        @if (data.hasActiveConnection) {
          <mat-hint> Varhaisin mahdollinen päivä: {{ minDate | date: 'dd.MM.yyyy' }} </mat-hint>
        }
        @if (!data.hasActiveConnection && data.latestTransactionDate) {
          <mat-hint> Varhaisin mahdollinen päivä: {{ minDate | date: 'dd.MM.yyyy' }} </mat-hint>
        }
      </mat-form-field>

      @if (data.hasActiveConnection) {
        <mat-checkbox [formField]="lomake.aktivoiHetiJosYhteysKatkeaa" style="margin-top: 10px"> Vaihda heti, jos pankkiyhteys katkeaa ennen valittua päivää </mat-checkbox>
      }
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button class="secondarybutton" (click)="cancel()">Peruuta</button>
  <button mat-button class="primarybutton" (click)="save()" [disabled]="!lomake().valid()">Tallenna</button>
</mat-dialog-actions>
